import React from 'react'
import EditModal from '../edit-modal'
import useClientLocation from '../../../hooks/use-client-location'

const ExperienceDuplicateScreen = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = params.experienceId
    return (
        <EditModal
            experienceId={experienceId}
            onClose={goBack}
            saveAsNew
        />
    )
}

export default ExperienceDuplicateScreen